import { render } from "./card-result-preview.vue?vue&type=template&id=6624e1d1&scoped=true&ts=true"
import script from "./card-result-preview.vue?vue&type=script&lang=ts"
export * from "./card-result-preview.vue?vue&type=script&lang=ts"

import "./card-result-preview.vue?vue&type=style&index=0&id=6624e1d1&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newD\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6624e1d1"]])

export default __exports__